module.exports = __webpack_public_path__ + "static/media/paladin.800e296c.svg";